/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReservationRequest } from '../../models/reservation-request';

export interface HealthFindrRequestReservationPost$Params {
      body?: ReservationRequest
}

export function healthFindrRequestReservationPost(http: HttpClient, rootUrl: string, params?: HealthFindrRequestReservationPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<string | null>> {
  const rb = new RequestBuilder(rootUrl, healthFindrRequestReservationPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BookingStrictHttpResponse<string | null>;
    })
  );
}

healthFindrRequestReservationPost.PATH = '/HealthFindr/RequestReservation';
